import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import orderBy from 'lodash/orderBy';
import classnames from 'classnames';
import {getOutcomeList, setEndBusiness} from '../../actions/businessOutcome';
import {modifyCall} from '../../actions/call';
import Loader from '../Components/Loader';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class SetBusinessOutcome extends Component {

  constructor(props) {
    super(props);
    this.state = {
      service: '',
      showErr: false,
      errorHeight: 0,
      searchFilter: ''
		};
  }

  // gets list of business Outcome from api call
  getOutcomeList = () => {
    this.setState({
      service: this.props.endBusinessId,
      loading: true,
      searchFilter: ''
    }, () => {
      this.props.getOutcomeList(this.props.serviceId).then(() => {
        this.setState({
          loading: false
        })
      }, (err) => {
        this.setState({
          loading: false,
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        });
        logData(err);
      });
    })
  }

  /**
   * closes the modal
   * @param  {string} key
   */
  close = (key) => {
    this.setState({
      service: '',
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });
  }
  // updates selected service
  changeService = (service, serviceName) => {
    this.setState({service, serviceName});
  }

  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  getErrorHeight = () => {
    if(document.getElementById('bo_alertWrapper')) {
      const errorHeight = document.getElementById('bo_alertWrapper').clientHeight;
      this.setState({
        errorHeight: errorHeight + 21
      });
    }
  }

  // updates state with search filter value
  handleSearchChange = (e) => {
    this.setState({
      searchFilter: e.target.value
    });
  }

  // renders list of business outcome
  renderList = () => {
    return orderBy(this.props.businessOutcome, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
    .filter(service => service.name && service.name.toLowerCase()
    .includes(this.state.searchFilter.toLowerCase()))
    .map(item => {
      if(item.name){
      return (
        <button
          key={item.id}
          type="button"
          onClick={() => this.changeService(item.id, item.name)}
          className={classnames(`list-group-item list-group-item${this.props.theme}`, {active: this.state.service==item.id})}>
            {item.name}
        </button>
      )
      }
    });
  }

  isSelectedOutcomeExistsInList = () => {
    return this.props.businessOutcome.filter((service) => {
      return (service.name && service.name.toLowerCase().includes(this.state.searchFilter.toLowerCase()))
    }).some(item => {
      return this.state.service==item.id;
    });
  }

  // submits the selected business outcome
  handleSubmit = () => {
    // shows error if no service is selected.
    if(!this.state.service || !this.isSelectedOutcomeExistsInList()){
      this.setState({
        errorMsg: this.props.translations.noOptionSelected[this.props.selectedLanguage],
        showErr: true
      }, () => {
        this.getErrorHeight();
      });
      return;
    }else{
      const payload = {
        callId: this.props.CallId,
        id: this.state.service,
      }
      // makes api call from action
      this.props.setEndBusiness(payload).then((res) => {
        if(res.data.result==true){
          if(this.props.outgoingServiceCb!==null){
            // triggers outgoingServiceCb prop to handle updates where needed
            this.props.outgoingServiceCb(this.props.CallId, this.state.service, this.state.serviceName);
            const newData = {
              id: this.props.CallId,
              end_business_id: this.state.service,
            };
            this.props.modifyCall(newData);
          }
          this.setState({
            service: '',
            showErr: false
          }, () => {
            this.props.handleClose(this.props.showModal);
          });
        }else{
          this.setState({
            errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
            showErr: true
          }, () => {
            this.getErrorHeight();
          });
        }
      }, (err) => {
        logData(err);
        this.setState({
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
          showErr: true
        }, () => {
          this.getErrorHeight();
        });
      });
    }
  }

  render(){
    const { 
      loading,
      showErr,
      errorHeight 
    } = this.state;
    const { translations, selectedLanguage, businessOutcome } = this.props;
    return (
      <Modal
        onEnter={this.getOutcomeList}
        show={this.props.showModal}
        onHide={() => this.close('showModal')}
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.businessOutcome[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {showErr && <div className="alertWrapper" id="bo_alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          {(!loading && businessOutcome.length>0) &&
            <div className="input-with-icon w-full">
            <input
            type="text"
            className={`form-control${this.props.theme} input-smm${this.props.theme}`}
            placeholder={translations.search[selectedLanguage]}
            style={ {marginBottom: '0.5rem'} }
            onChange={ this.handleSearchChange }
          />
          <span className="icon icon-magnifying-glass" />
          </div>}
          {loading && <Loader width="20px" height="20px" />}
          <div className="list-group" style={{maxHeight: showErr ? `calc(345px - ${errorHeight}px)` : 345, overflow: 'auto'}}>
            {(!loading) && this.renderList()}
            {(!loading && businessOutcome.length==0) &&
              <h5>{translations.noneAssigned[selectedLanguage]}</h5>
            }
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close('showModal')}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
            style={ { width: !loading && businessOutcome.length>0 ? '50%' : '100%' } }
            >
              {translations.cancel[selectedLanguage]}
          </button>
          {(!loading && businessOutcome.length>0) && <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>}
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentConfig: state.agentConfig,
        agentInfo: state.agentInfo,
        businessOutcome: state.businessOutcome,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}
function mapDispatchToProps (dispatch) {
    return bindActionCreators({getOutcomeList, setEndBusiness,modifyCall}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SetBusinessOutcome);



// WEBPACK FOOTER //
// ./src/agent/modals/setBusinessOutcome.js